import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import moment from 'moment';
import _ from 'lodash';

import AccountNumberAutoSuggests from '../../common/accountNumberAutoSuggests';
import RequestReturnFileWarningDialog from '../../../dialogs/requestReturnFileWarningDialog';
/* Dialogs */
import SelectProductsToReturnOverlayDialog from '../../../dialogs/selectProductsToReturnOverlayDialog';

import { routes } from '../../../../redux/api/routes';
const {
	orders,
	bootAPIUrl,
} = routes;
import {
	sendRequest
} from '../../../../redux/api/sendRequest';

/* Actions */
import {
	getOrderList,
	saveRequestCreditList,
	saveRequestCreditPimData,
	saveSerialCreditData,
	setRequestCreditDetails,
	getOrderDetails,
	sendEmailSuccessDialog,
	dropProductSpecsEmail,
	updateRequestCreditParams,
	ajaxRequestInitiated,
	ajaxRequestCompleted,
	savePreviousReturnAndCreditDetails,
} from '../../../../redux/actions';

class RequestCredit extends Component {

	constructor(props) {
		super(props);
		this.state = {
			showSelectProductsToReturnOverlayDialog: false,

			resultFilterBy: '',
			resultFilterByValue: '',

			accountNumber: '',
			errorMessage: '',

			filterConfirmationMessage: '',
			olderThanInvoiceAgeMessage: 'This request is older than allowed by the Return and Scrap Policy.',
			olderThanYearMessage:'As-Is invoices are not eligible for credit beyond 1 year.',
			olderThanTwoYearMessage:'Invoices are not eligible for credit beyond 2 years.',
			sortBy: 'orderDate,desc',
			filterListOfOrders: {
				param: {
					filterBy: 'serialNumber',
					filterString: '',
					creditType: '',
					serialNumber:''
				},
				error: {
					creditTypeError: '',
					filterByError: '',
					filterStringError: '',
					modelNumberError: '',
					serialNumberError: ''
				}
			},

			requestCreditList: null,

			customerServiceForm: {
				param: {
					msNumber: '',
					poNumber: '',
					invoice: '',
					item: '',
					serial: '',
					returnReason: '',
					address: '',
					contactInfo: ''
				},
				error: {
					msNumberError: '',
					poNumberError: '',
					invoiceError: '',
					itemError: '',
					serialError: '',
					returnReasonError: '',
					addressError: '',
					contactInfoError: ''
				}
			},
			isSerialNumberSearch: false,

			showNoOrderFoundForm: false,
			showClickHereLink: false,
			showForm: false,
			allowedCreditTypesList: [],
			showRequestReturnFileWarningDialog:false,
			showSerialErrorMessage : false
		}
		// this.hideFilterResultMessage = this.hideFilterResultMessage.bind(this);
		this.getOrderList = this.getOrderList.bind(this);
		this.processAndFilterResponse = this.processAndFilterResponse.bind(this);
	}

	componentWillMount() {
		window.scrollTo(0, 0);
		const self = this;
		const { history } = self.props;
		if(!self.props.hasRequestCreditAccess) {
			browserHistory.push('/home');
		} else {
			let { allowedCreditTypesList, userDetails, accountResponsibilityData } = self.props.state.user;
			if (userDetails.typeOfUser === 'customer') {
				allowedCreditTypesList = accountResponsibilityData.responseObject.allowedCreditTypes.filter(type => type !== 'No Charge Replacement Parts orders');
			}
			self.setState({
				allowedCreditTypesList
			}, () => {
				if(history.length > 0 && history[history.length - 1].pathname !== '/requestcreditstep1' && history[history.length - 1].pathname !== '/previousreturnandcredit' && history[history.length - 1].pathname !=='/requestcreditstep2') {
					self.props.setRequestCreditDetails(null);
					self.props.saveRequestCreditList(null);
					self.props.updateRequestCreditParams(null);
				} else {
					const { requestCreditList, requestCreditFilterListOfOrders } = self.props.state.order;
					if(requestCreditList && requestCreditFilterListOfOrders) {
						self.setState({
							filterListOfOrders: requestCreditFilterListOfOrders,
							requestCreditList,
							resultFilterBy: requestCreditFilterListOfOrders.param.filterBy,
							resultFilterByValue: requestCreditFilterListOfOrders.param.filterString,
						});
						self.props.setRequestCreditDetails(null);
						self.props.saveRequestCreditList(null);
					}
				}
			});
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		var self = this,
			accountNumber = self.props.getSelectedAccountNumber();
		if(accountNumber) {
			self.setState({
				accountNumber: accountNumber
			});
		} else {
			browserHistory.push('/manageorders');
		}
	}

	getDataByFilterOptions(orderHeader) {
		const self = this;
		let data = null;
		const { filterListOfOrders } = self.state;
		const resultFilterBy = filterListOfOrders.param.filterBy,
			resultFilterByValue = filterListOfOrders.param.filterString;
		if (resultFilterBy === 'invoiceNumber') {
			// Take the same invoiceNumber which user has entered
			data = orderHeader.invoices.invoice.find(itm => itm.invoiceNumber === resultFilterByValue);
		} else {
			// Take the latest invoice number from array
			data = _.maxBy(orderHeader.invoices.invoice, 'invoiceNumber');
		}
		return data;
	}

	processInvoiceNumberDate(orderHeader) {
		const self = this;
		let invoiceNumber = orderHeader.invoiceNumber;
		let invoiceDate = orderHeader.invoiceDate;
		let data = self.getDataByFilterOptions(orderHeader);
		if(data) {
			invoiceNumber = data.invoiceNumber;
			invoiceDate = data.invoiceDate;
		}

		return {
			invoiceNumber,
			invoiceDate
		};
	}

	getOrderList(queryString, callback) {
		const self = this;
		self.setState({
			requestCreditList: null,
			errorMessage: '',
			filterConfirmationMessage: '',
		}, () => {
			self.props.getOrderList(queryString, (response) => {
				if(!response.status) {
					self.setState({
						errorMessage: response.responseMessage
					});
				} else {
					if(self.state.isSerialNumberSearch) {
						response.responseObject = response.responseObject ;
						// Filter SHIP_OR_RETURN === "Ship" for all users
						// account number should be selected account number
						const serialCreditData = response.responseObject;
						response.responseObject = response.responseObject.filter(item => {
							return item.line_TYPE === "Standard Line" && item.account_NUMBER === self.props.getSelectedAccountNumber()
						});
						if (response.responseObject.length === 0 && self.state.isNextServiceCallRequired) {
							self.props.saveSerialCreditData(serialCreditData);
							self.setState({
								isNextServiceCallRequired: false,
							}, () => {
								self.getOrderList(self.state.queryStringBkp, callback);
							});
						} else {
							const promises = [];
							self.props.ajaxRequestInitiated();
							response.responseObject.forEach(item => {
								promises.push(
									sendRequest(
										bootAPIUrl,
										orders.getOrderListBoot.path,
										'',
										orders.getOrderListBoot.method,
										`accountNumber=${self.state.accountNumber}&orderNumber=${item.order_NUMBER}`
									)
								);
							});
							Promise.all(promises).then((responses) => {
								// logic to combine all responses and then run call back
								let responseObject = [];
								let response = {};
								const returnLinesForSerialNumber = [];
								const returnOrderNumbers = [];
								if(responses.length > 0) {
									responses.forEach(resp => {
										responseObject = responseObject.concat(resp.responseObject);
										// Check return lines for the item that contains this serial number, if there are no previous returns for the serial number, we need to fetch return order details to check previous credits
										if (resp.responseObject && resp.responseObject[0] && resp.responseObject[0].orderDetail && resp.responseObject[0].orderDetail.orderLine) {
											const foundLine = resp.responseObject[0].orderDetail.orderLine.find(item => item.serialNumber && item.serialNumber.split(/[\s,]+/).some(serialNumberItem => serialNumberItem.startsWith(this.state.filterListOfOrders.param.serialNumber.trim())));
											foundLine && foundLine.returnDetails && foundLine.returnDetails.returnLine &&
												foundLine.returnDetails.returnLine.forEach(returnLineItem => {
													returnLineItem.originalOrderNumber = resp.responseObject[0].orderHeader && resp.responseObject[0].orderHeader.orderNumber;
													if (returnLineItem.returnNumber) {
														returnLinesForSerialNumber.push(returnLineItem);
														if (!returnOrderNumbers.includes(returnLineItem.returnNumber)) {
															returnOrderNumbers.push(returnLineItem.returnNumber);
														}
													}
												});
										}
									});
									response = {
										...responses[0],
										responseObject
									}
								} else {
									response.responseObject = [];
								}
								serialCreditData && serialCreditData.forEach(serialCreditItem => {
									if (serialCreditItem.line_TYPE === 'Return Line') {
										const foundReturnLine = returnLinesForSerialNumber.find(returnLineForSerialNumber => returnLineForSerialNumber.returnNumber === serialCreditItem.order_NUMBER);
										serialCreditItem.originalOrderNumber = foundReturnLine && foundReturnLine.originalOrderNumber;
									}
								})
								self.props.saveSerialCreditData(serialCreditData);
								self.props.ajaxRequestCompleted();
								// If there is no previous return request for the serial number, check for previous credit requests
								if (returnLinesForSerialNumber.length) {
									self.props.resetParallelCallsOrderDetails();
									self.props.getOrderDetailsInParallelBatches(returnOrderNumbers, () => {
										const updatedSerialCreditData = [...(self.props.state.order.serialCreditData || [])];
										for (const returnLine of returnLinesForSerialNumber) {
											const foundReturnOrderDetails = self.props.orderDetailsOfOrderNumbers.find(returnOrderDetails => returnOrderDetails &&
												returnOrderDetails.orderNumber === returnLine.returnNumber);
											let matchingSerialNumber;
											const foundReturnOrderLine = foundReturnOrderDetails && foundReturnOrderDetails.items && foundReturnOrderDetails.items.find(item => item.lineType === 'Other Credit' && +item.lineNo === +returnLine.lineNumber &&
												item.lineStatus && item.lineStatus.toUpperCase() !== 'CANCELLED' && item.userItemDescription && item.userItemDescription.split(/[\s,]+/).some(userItemDescriptionItem => {
													if (userItemDescriptionItem.startsWith(this.state.filterListOfOrders.param.serialNumber.trim())) {
														matchingSerialNumber = userItemDescriptionItem;
														return true;
													}
													return false;
												})
											);

											if (foundReturnOrderLine) {
												updatedSerialCreditData.push({
													line_NUMBER: foundReturnOrderLine.lineNo,
													invoice_NUMBER: foundReturnOrderLine.invoiceNumber,
													ordered_ITEM: foundReturnOrderLine.item,
													order_NUMBER: foundReturnOrderDetails.orderNumber,
													line_TYPE: foundReturnOrderLine.lineType,
													invoice_DATE: foundReturnOrderLine.invoiceDate,
													account_NUMBER: foundReturnOrderDetails.accountNumber,
													fm_SERIAL_NUMBER: matchingSerialNumber,
													actual_SHIPMENT_DATE: '',
													order_TYPE: foundReturnOrderDetails.orderType,
													attribute1: foundReturnOrderLine.internalItem,
													returnReason: foundReturnOrderLine.returnReason,
													originalOrderNumber: foundReturnOrderLine.originalOrderNumber
												})
											}
										}
										self.props.saveSerialCreditData(updatedSerialCreditData);
										self.processAndFilterResponse(response, callback);
									});
								} else {
									self.processAndFilterResponse(response, callback);
								}
							});
						}
					} else {
						self.processAndFilterResponse(response, callback);
					}
				}
			});
		});
	}

	processAndFilterResponse(response, callback) {
		const self = this;
		const { typeOfUser } = self.props.state.user.userDetails;
		let finalObject = [];
		response.responseObject = response.responseObject || [];

		// Excluded CANCELLED orders
		// atlease one line should standard line or bill only line
		// exclude GEA Parts agreement type orders
		response.responseObject = response.responseObject.filter(item =>
			item && item.orderHeader &&
			item.orderHeader.orderStatus !== 'CANCELLED' &&
			item.orderDetail.orderLine.find(itm => (itm.lineType === "Standard Line" || itm.lineType === "Bill Only Line")) &&
			self.props.getAttributeBySalesAgreement(item.orderHeader.salesAgreement.agreementNumber, 'AGREEMENT_TYPE') !== 'GEA Parts'
		);

		// let showClickHereLink = (response.responseObject.length === 0 ? true : false);
		let filterConfirmationMessage = (response.responseObject.length === 0 ? 'No orders found meeting the specified criteria; please try your search again.' : '');
		if(response.responseObject.length > 0) {
			// Check if all records are of ENTERED Status or not
			const enteredOrders = _.filter(response.responseObject, item => {
				return item.orderHeader.orderStatus !== 'ENTERED';
			});

			finalObject = enteredOrders;

			if(enteredOrders.length === 0) {
				finalObject = [];
				filterConfirmationMessage = "Order is in Entered status and not eligible for return.";
			} else {
				finalObject = [];
				enteredOrders.forEach(item => {
					if(typeOfUser === 'customer') {
						if(!item.orderHeader.invoiceDate) {
							finalObject.push(item);
						}
					} else {
						finalObject.push(item);
					}
				});
				if(finalObject.length === 0) {
					filterConfirmationMessage = 'Order is not eligible for return.';
				}
			}
		}
		self.setState({
			filterConfirmationMessage,
		}, () => {
			const sortBy = self.state.sortBy.split(',')[0],
				sortOrder = self.state.sortBy.split(',')[1];
			response.responseObject = _.orderBy(finalObject, (e) => { return e.orderHeader[sortBy]}, [sortOrder]);
			callback && callback(response, false);
		});
	}

	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	handleFilterListOfOrders(event) {
		event.preventDefault();
		var self = this;
		let { filterListOfOrders, inValid  } = this.state;
		let anyError = false;
		if (
			(filterListOfOrders.param.filterBy === 'orderNumber' && !self.props.isValidOrderNumer(filterListOfOrders.param.filterString)) ||
			(filterListOfOrders.param.filterBy === 'referenceNumber' && !self.props.isValidReferenceNumber(filterListOfOrders.param.filterString))
		) {
			anyError = true;
		}
		if(inValid) {
			filterListOfOrders.param.modelNumber = ''
		}
		if(!anyError && filterListOfOrders.param.creditType !== '' && filterListOfOrders.param.filterBy !== '' &&
			(
				(filterListOfOrders.param.filterBy !== 'serialNumber' && filterListOfOrders.param.filterString !== '') ||
				(filterListOfOrders.param.creditType !== '' && filterListOfOrders.param.filterBy === 'serialNumber' && filterListOfOrders.param.serialNumber !== '')
			)
		) {
			let queryStringParams = '';
			if(filterListOfOrders.param.filterBy !== '') {
				if(filterListOfOrders.param.filterBy !== 'serialNumber' && filterListOfOrders.param.filterString !== '') {
					let filterString = filterListOfOrders.param.filterString.trim();
					if(filterListOfOrders.param.filterBy === 'poNumber') {
						filterString = encodeURIComponent(filterString);
					}
					queryStringParams += `&${filterListOfOrders.param.filterBy}=${filterString}`;
				} else {
					if(filterListOfOrders.param.modelNumber) {
						queryStringParams += `&modelNumber=${filterListOfOrders.param.modelNumber.trim()}`;
					}
					if(filterListOfOrders.param.serialNumber) {
						const pattern = /^[A-Z]{2}\d{6}$/;
						if(!pattern.test(filterListOfOrders.param.serialNumber.trim().toUpperCase())){
							self.setState({
								showSerialErrorMessage : true,
								showRequestReturnFileWarningDialog : true
							});
							return
						}
						else{
							queryStringParams += `&serialNumber=${filterListOfOrders.param.serialNumber.trim().toUpperCase()}`;
						}
					}
				}
			}
			let isNextServiceCallRequired = false;
			if (filterListOfOrders.param.filterBy === 'serialNumber' && filterListOfOrders.param.serialNumber !== '') {
				//const searchStr = filterListOfOrders.param.serialNumber.toLowerCase();
				//if(searchStr.indexOf('-ad1') === -1 || searchStr.indexOf('-ad1') !== searchStr.length - 4) {
					//isNextServiceCallRequired = true;
				//}
			}
			self.setState({
				showForm: false,
				showClickHereLink: false,
				isSerialNumberSearch: filterListOfOrders.param.filterBy === 'serialNumber' && filterListOfOrders.param.serialNumber !== '',
				isNextServiceCallRequired,
				queryStringBkp: isNextServiceCallRequired ? `requestType=requestReturn&accountNumber=${self.state.accountNumber}${queryStringParams}-AD1` : '',
			}, () => {
				self.getOrderList(`requestType=requestCredit&accountNumber=${self.state.accountNumber}${queryStringParams}`, (response, showClickHereLink) => {
					self.setState({
						showClickHereLink: showClickHereLink,
						requestCreditList: response,
						resultFilterBy: filterListOfOrders.param.filterBy,
						resultFilterByValue: filterListOfOrders.param.filterString
					});
				});
			});

		} else {
			var error = this.state.filterListOfOrders.error;
			if(filterListOfOrders.param.creditType === '') {
				error.creditTypeError = 'error';
			}
			if(filterListOfOrders.param.filterBy === '') {
				error.filterByError = 'error'
			} else {
				if (anyError) {
					error.filterStringError = 'error'
				} else {
					if(filterListOfOrders.param.filterBy === 'serialNumber') {
						error = {
							...error,
							filterStringError: '',
							serialNumberError: filterListOfOrders.param.serialNumber === '' ? 'error' : '',
							modelNumberError: filterListOfOrders.param.modelNumber === '' ? 'error' : '',
						}
					} else {
						error = {
							...error,
							filterStringError: filterListOfOrders.param.filterString === '' ? 'error' : '',
							serialNumberError: '',
							modelNumberError: '',
						}
					}
				}
			}

			this.setState({
				filterListOfOrders: {
					...this.state.filterListOfOrders,
					error: error
				},
				filterConfirmationMessage: ''
			})
		}
	}

	fetchOrderDetails(response) {
		const self = this;
		const orderNumbers = [];
		response.responseObject.forEach(itm => {
			if(itm.orderHeader.orderNumber) {
				orderNumbers.push(itm.orderHeader.orderNumber);
			}
		});
		self.props.getOrderDetailsInParallelBatches(orderNumbers);
	}

	componentWillUnmount() {
		this.props.updateRequestCreditParams(this.state.filterListOfOrders);
	}

	updateParams(formName, event) {
		//Reseting Errors on change
		let error = this.state[formName].error;
		let param = this.state[formName].param;
		for (var key in error) {
			if (error.hasOwnProperty(key)) {
				if(event.target.name === 'filterBy' && key !== 'creditTypeError') {
					error[key] = '';
				} else if(event.target.name === 'creditType' && key === 'creditTypeError') {
					error[key] = '';
				}
			}
		}
		param = {
			...param,
			filterString: event.target.name === 'filterBy'?'':this.state[formName].param.filterString,
			[event.target.name]: event.target.value
		};
		if(formName === 'filterListOfOrders') {
			if(event.target.name === 'filterBy') {
				param = {
					...param,
					modelNumber: '',
					serialNumber: '',
				}
				error = {
					...error,
					modelNumberError: '',
					serialNumberError: '',
				};
				if(this.modelNumber)
					this.modelNumber.value = '';
				if(this.serialNumber)
					this.serialNumber.value = '';
			} else if (event.target.name === 'filterString') {
				error = {
					...error,
					filterStringError: '',
				};
			}
			else if(event.target.name == 'serialNumber'){
				const serialNumber = event.target.value.toUpperCase(); 
				event.target.value = serialNumber;
				param = {
					...param,
					serialNumber: serialNumber,
				}
			}
			
		}
		this.setState({
			[formName]: {
				param,
				error
			}
		});
	}

	handleSortBy(event) {
		let sortBy = event.target.value.split(',')[0],
			sortOrder = event.target.value.split(',')[1],
			{ requestCreditList } = this.state,
			isAnyDateFilter = sortBy.indexOf('Date') !== -1;
		var self = this;
		requestCreditList.responseObject = _.orderBy(requestCreditList.responseObject, (e) => {
			return !isAnyDateFilter?e.orderHeader[sortBy]:self.props.formatDate(e.orderHeader[sortBy], 'MM/DD/YY')
		}, [sortOrder]);
		this.setState({
			sortBy: event.target.value,
			requestCreditList,
		}, () => {
			// self.props.saveRequestCreditList(JSON.parse(JSON.stringify(requestCreditList)));
		});
	}

	handleResetForm(event, whichFilter) {
		const self = this;
		self.setState({
			filterListOfOrders: {
				param: {
					...self.state.filterListOfOrders.param,
					filterBy: 'serialNumber',
					filterString: '',
					creditType: '',
					serialNumber:''
				},
				error: {
					...self.state.filterListOfOrders.error,
					creditTypeError: '',
					filterByError: '',
					filterStringError: '',
					modelNumberError: '',
					serialNumberError: ''
				}
			},
			requestCreditList: null,
		});
	}

	handleFetchOrderDetails(orderHeader, wheretoRedirect, event) {
		event.preventDefault();
		const self = this;
		self.props.getOrderDetails('orderNumber='+orderHeader.orderNumber+'&requestType=getOrderDetails&accountNumber='+self.props.getSelectedAccountNumber(), (response) => {
			this.props.updateRequestCreditParams(self.state.filterListOfOrders);
			if(!response.status) {
				self.setState({
					errorMessage: response.responseMessage
				});
			} else {
				const { allSelectedAccountsAllPriceSources } = self.props.state.user;
				const billToLocationDetails = response.responseObject.billingAddress ? response.responseObject.billingAddress.locationId : null;
				let isValidBillTo = true;
				const creditType = self.state.filterListOfOrders.param.creditType;
				const saDetails = allSelectedAccountsAllPriceSources.find(item => item.AGREEMENT_NUMBER.toString() === orderHeader.salesAgreement.agreementNumber);
				if (billToLocationDetails && saDetails && saDetails.BILL_TO_LOCATION && billToLocationDetails !== saDetails.BILL_TO_LOCATION) {
					isValidBillTo = false;
				}
				response.responseObject = {
					...response.responseObject,
					originalOrderDate: response && response.responseObject && response.responseObject.orderDate,
					isValidBillTo,
					creditType,
					poNumberBackup: response && response.responseObject && response.responseObject.poNumber
				};
				//Save manage order list into store
				response.responseObject.items.forEach(itm => {
					itm.bkpSerialNumber = itm.serialNumber;
					itm.bkpItem = itm.item;
					itm.item = itm.internalItem;
				});
				if(self.state.filterListOfOrders.param.creditType === 'Delivery/Services/Fees') {
					self.props.setRequestCreditDetails(response);
					self.props.saveRequestCreditList(self.state.requestCreditList);
					browserHistory.push('/' + wheretoRedirect);
				} else {
					const tempResponse = JSON.parse(JSON.stringify(response));
					self.props.getItemTypeByOrderDetails(response.responseObject, resp => {
						if(!resp.status) {
							self.setState({
								errorMessage: resp.responseMessage
							})
						} else {
							self.props.setRequestCreditDetails({
								...tempResponse,
								responseObject: resp.orderDetails
							});
							self.props.saveRequestCreditPimData(resp.pimData);
							self.props.saveRequestCreditList(self.state.requestCreditList);
							browserHistory.push('/' + wheretoRedirect);
						}
					});
				}
			}
		});
	}

	showForm(flag, event) {
		event.preventDefault();
		this.setState({
			showForm: flag
		})
	}

	handleSubmitCustomerServiceRequest(event) {
		event.preventDefault();
		let self = this,
			params = self.state.customerServiceForm.param,
			error = self.state.customerServiceForm.error,
			formError = false;

		//Reset all errors
		for(var key in error) {
            if(params[key.replace("Error","")] === "") {
                error[key] = 'error';
                formError = true;
            } else {
				error[key] = '';
			}
        }

		self.setState({
			customerServiceForm: {
				...self.state.customerServiceForm,
				param: params,
				error: error
			}
		});

		if(!formError) {
			self.props.sendEmailSuccessDialog(false);
			self.props.dropProductSpecsEmail(self.state.customerServiceForm.param, "emailType=requestCredit", response => {
				self.props.sendEmailSuccessDialog(true);
				self.setState({
					showClickHereLink: false,
					showForm: false
				});
			});

		}
	}

	handleProductNumberChange(itemIndex, productDetails) {
		const self = this;
		if(productDetails && productDetails.status) {
			self.setState({
				filterListOfOrders: {
					...self.state.filterListOfOrders,
					param: {
						...self.state.filterListOfOrders.param,
						modelNumber: productDetails.sku
					}
				},
				inValid: false,
			});
		}
	}

	handleChangeProductNumberTextBox(indx, productNumber, productListSuggestion, inValid) {
		const self = this;
		self.setState({
			inValid,
			filterListOfOrders: {
				param: {
					...self.state.filterListOfOrders.param,
					modelNumber: productNumber,
				},
				error: {
					...self.state.filterListOfOrders.error,
					modelNumberError: '',
				}
			},
		});
	}

	handleReturnLinesDetails(returnLines, orderHeader, event) {
		event && event.preventDefault();
		const self = this;
		let orderNum = orderHeader.orderNumber;
		self.props.savePreviousReturnAndCreditDetails({
			orderNum,
			returnLines
		});
		self.props.saveRequestCreditList(self.state.requestCreditList);
		browserHistory.push("/previousreturnandcredit");
	}

	handleContinue(orderHeader, attribute,fm_SERIAL_NUMBER,resultLineNumber,  event) {
		event.preventDefault();
		const self = this;
		const creditType = self.state.filterListOfOrders.param.creditType;
		self.props.getOrderDetails('orderNumber='+orderHeader.orderNumber+'&requestType=getOrderDetails&accountNumber='+self.props.getSelectedAccountNumber(), (response) => {
			this.props.updateRequestCreditParams(self.state.filterListOfOrders);
			response.responseObject = {
					...response.responseObject,
					originalOrderDate: response.responseObject.orderDate,
				creditType,
				poNumberBackup: response.responseObject.poNumber
			};
			response.responseObject.items.forEach(itm=> {
				itm.bkpSerialNumber = itm.serialNumber;
				itm.bkpItem = itm.item;
				itm.item = itm.internalItem;
			});
			self.props.setRequestCreditDetails(response);
			self.props.saveRequestCreditList(self.state.requestCreditList);
			self.props.getItemTypeByOrderDetails(response.responseObject, resp => {
				if(!resp.status) {
					self.setState({
						errorMessage: resp.responseMessage
					})
				} else {
					self.props.saveRequestCreditPimData(resp.pimData);
				}
			});
			response.responseObject.items = response.responseObject && response.responseObject.items.filter(itm =>{return itm.serialNumber != "" && itm.item == attribute})
			self.callBackContinue( response.responseObject, fm_SERIAL_NUMBER, resultLineNumber);
		});
	}

	callBackContinue(obj, fm_SERIAL_NUMBER, resultLineNumber) {
		const self = this;
		const items = [];
		obj.items.forEach(itm => {
			items.push({
				...itm,
				originalSerialNumbers: itm.serialNumber,
				serialNumber:fm_SERIAL_NUMBER,
				selected:(itm.lineNo == resultLineNumber[0] && itm.shipmentNumber == resultLineNumber[1])? true:false,
				returnQuantity:1,
			});
		});
		self.props.setRequestCreditDetails({
			responseObject: {
				...obj,
				items,
				originalOrderNumber: obj.orderNumber,
				shippingMethod: obj.deliveryMethod,
				deliveryInstructions: "",
				requestedDeliveryDate: ""
			}
		});
		browserHistory.push("/requestcreditstep2");
	}


    render() {
		const self = this;
		const {
			requestCreditList,
			inValid,
			filterListOfOrders: {
				param: {
					filterBy,
					creditType,
				}
			},
			allowedCreditTypesList
		} = self.state;
		let showOlderThanInvoiceMessage = false;
		let showOlderThanInvoiceMessageForEmployee = false;
		let isOlderThanTwoYear = false;
		let isOlderThanYear = false;
		let isAlreadyRetrnQtyLessThenOrdered = true;
		let isReturnedSerialNumberInAnyOrder = false, isCreditedSerialNumberInAnyOrder = false;
		const { CUSTOMERCLASSCODE} = self.props.state.user.accountDetail.responseObject !== null && self.props.state.user.accountDetail.responseObject !== 'undefined' ? self.props.state.user.accountDetail.responseObject[0]: '';
        return (
			<div>
				<div className="d-none d-sm-block">
					<div className="push">
						<h1 className="pageTitle">Request Credit</h1>
					</div>
					<div className="push">
						<p>To request a credit, select the credit type first, and then find the order containing the product(s) for which you are requesting credit.</p>
						<div className="margin-btm-2em">
							<select onChange={this.updateParams.bind(this, 'filterListOfOrders')} value={creditType} className={"halfWidth " + this.state.filterListOfOrders.error.creditTypeError} name="creditType">
								<option value="">Choose the type of credit you are requesting</option>
								{allowedCreditTypesList.map((item, index) => {
									return <option value={item} key={index}>{item}</option>
								})}
							</select>
						</div>
						<form className="returnProductsFilterForm" name="returnProductsFilterForm" id="returnProductsFilterForm" onSubmit={this.handleFilterListOfOrders.bind(this)}>
							<div className="filterBoxType2 particularOrderShadedBox">
								<h3 style={{marginBottom: 14, marginTop: 14}}>Filter the list of orders by using the search criteria below.</h3>
								<div style={{float: 'left', width: '53%', position: 'relative'}}>
									<p style={{marginTop: 0}}>Filter by P.O. #, CSO (order number), Serial #, Invoice # or Order Reference #</p>
									<p>
										<select ref={(select) => this.filterBy = select} defaultValue={this.state.filterListOfOrders.param.filterBy} name="filterBy" onChange={this.updateParams.bind(this, 'filterListOfOrders')} className={"fullWidth " + this.state.filterListOfOrders.error.filterByError}>
											<option value="">Select one...</option>
											<option value="poNumber">P.O. #</option>
											<option value="orderNumber">CSO (Order number)</option>
											<option value="serialNumber">Serial #</option>
											<option value="invoiceNumber">Invoice #</option>
											<option value="referenceNumber">Order Reference # (CTN #)</option>
										</select>
									</p>
									{this.state.filterListOfOrders.param.filterBy !== 'serialNumber' &&
										<p>
											<input ref={(input) => this.filterString = input} onChange={this.updateParams.bind(this, 'filterListOfOrders')} className={"fullWidth " + this.state.filterListOfOrders.error.filterStringError + (filterBy === 'poNumber' || filterBy === 'referenceNumber' ? ' text-transform-uppercase' : '')} type="text" name="filterString" disabled={this.state.filterListOfOrders.param.filterBy === ''} value={this.state.filterListOfOrders.param.filterString} />
										</p>}
									{this.state.filterListOfOrders.param.filterBy === 'serialNumber' &&
										<div className={this.state.filterListOfOrders.error.modelNumberError + ' auto-width-input'}>
											<AccountNumberAutoSuggests onChangeProductNumberTextBox={this.handleChangeProductNumberTextBox.bind(this)} updateQuickOrderState={this.handleProductNumberChange.bind(this)} size={8} placeHolder="Model #" />
											{inValid
												?<span className="red">Invalid product Number.</span>
												:null
											}
										</div>
									}
									{this.state.filterListOfOrders.param.filterBy === 'serialNumber' &&
										<p>
											<input placeholder="Serial # e.g., AB123456" 
											ref={(input) => this.serialNumber = input} 
											onChange={this.updateParams.bind(this, 'filterListOfOrders')} 
											className={"fullWidth " + this.state.filterListOfOrders.error.serialNumberError} 
											type="text" 
											name="serialNumber"
											maxLength={8} 
											disabled={this.state.filterListOfOrders.param.filterBy !== 'serialNumber'} 
											value={this.state.filterListOfOrders.param.serialNumber} />
										</p>}
									<p>
										<input type="submit" value="Search" />
										&nbsp; &nbsp;
										<input type="reset" className="blue looksLikeALink" onClick={this.handleResetForm.bind(this, 'other')} value="Clear Search" />
									</p>
								</div>
								<div className="clear" />
							</div>
						</form>
					</div>
					<p className="red bold">{this.state.errorMessage}</p>
					<p className="bold"><b>{this.state.filterConfirmationMessage}</b></p>
					{this.state.showClickHereLink && <p>Can’t find your order please click <a href="" onClick={this.showForm.bind(this, true)}>here</a></p>}
					{!this.state.showClickHereLink && requestCreditList && requestCreditList.status && !this.state.filterConfirmationMessage &&
						<div className="push">
							<div className="captionAboveTable">
								<div className="columns twoColumns">
									<div className="column">
										<div className="bold big">{requestCreditList.responseObject.length} Orders</div>
									</div>
									<div className="column textRight">
										<form className="manageOrdersSortBy" name="manageOrdersSortBy" id="manageOrdersSortBy">
											<label>
												Sort by: &nbsp;
												<select onChange={this.handleSortBy.bind(this)} name="sortBy" defaultValue={this.state.sortBy}>
													<option value="orderNumber,asc">CSO (Order number)</option>
													<option value="orderDate,desc">Order Date</option>
													<option value="invoiceDate,desc">Invoice Date</option>
													<option value="ponumber,desc">P.O. #</option>
													<option value="createdBy,desc">Entered By</option>
												</select>
											</label>
										</form>
									</div>
								</div>
							</div>
							<table className="dataTable returnProductsOrderListTable withAlternatingTbodyElements">
								<thead>
									<tr>
										<th className="orderNumber">CSO (Order number)</th>
										<th className="orderDate">Order Date</th>
										<th className="invoiceNumber">Invoice #</th>
										<th className="invoiceDate">Invoice Date</th>
										<th className="poNumber">P.O. #</th>
										<th className="product">Product</th>
										<th className="serial">Serial#</th>
										<th>Previous Returns/<br />Credits</th>
									</tr>
								</thead>
								<tbody>
									{requestCreditList.responseObject.length === 0
										?<tr>
											<td colSpan={6}>No orders found meeting the specified criteria; please try your search again.</td>
										</tr>
										:null
									}
									{requestCreditList.responseObject.length > 0 && requestCreditList.responseObject.map((item, index) => {
										let { orderHeader, orderDetail } = item,
											{ attribute } = orderHeader.attributes;
										attribute = attribute?_.find(attribute, ['name', 'Attribute2']):null;
										let isReturnedSerialNumberInCurrentOrder = false, isCreditedSerialNumberInCurrentOrder = false;
										const {
											invoiceNumber,
											invoiceDate,
										} = self.processInvoiceNumberDate(orderHeader);
										let invoice_NUMBER , invoice_DATE, attribute1, fm_SERIAL_NUMBER, line_NUMBER ='';
										self.props.state.order.serialCreditData && self.props.state.order.serialCreditData.length > 0 && self.props.state.order.serialCreditData.filter((itm)=>{
											if(itm.order_NUMBER == orderHeader.orderNumber){
												invoice_NUMBER =itm.invoice_NUMBER;
												invoice_DATE =  itm.invoice_DATE; 
												attribute1 = itm.attribute1;
												fm_SERIAL_NUMBER = itm.fm_SERIAL_NUMBER;
												line_NUMBER = itm.line_NUMBER;
											}
											// Check if any previous returns/credits present in the current order when user searches with a serial number,
											// we need it to enable or disable ordernumber/serial number hyperlinks and for previous return/credit messages
											if (itm.originalOrderNumber === orderHeader.orderNumber) {
												if (itm.line_TYPE === 'Return Line') {
													isReturnedSerialNumberInCurrentOrder = true;
													isReturnedSerialNumberInAnyOrder = true;
												} else if (itm.line_TYPE === 'Other Credit') {
													isCreditedSerialNumberInCurrentOrder = true;
													isCreditedSerialNumberInAnyOrder = true;
												}
											}
										});
										let returnLines ='';
										let serialNumberHyperLink = false;
										let hyperlinkSerial = false;
										let resultLineNumber = line_NUMBER.split('.');
										orderDetail && orderDetail.orderLine && orderDetail.orderLine.map(itm => {
											if(itm.item === attribute1  && itm.lineNum == resultLineNumber[0] && itm.shipmentNum == resultLineNumber[1] && itm.returnDetails && itm.returnDetails.returnLine && itm.returnDetails.returnLine.length >0){
												returnLines = itm.returnDetails.returnLine.filter(returnItems =>{
													let orderedQuantity =parseInt(itm.orderedQty, 10);
													let calculatedReturnQuantity =orderedQuantity - returnItems.authorizedQty;
													if(calculatedReturnQuantity == 0){
														hyperlinkSerial = true;	
													}
													if(calculatedReturnQuantity > 0){
														hyperlinkSerial = false;
													}
													return returnItems.lineType.toLowerCase() !== 'bill only line'
											});
											let totalAlreadyRetrnedQty = 0 
											if(returnLines) {
												totalAlreadyRetrnedQty = _.sumBy(returnLines,'authorizedQty');
												isAlreadyRetrnQtyLessThenOrdered = totalAlreadyRetrnedQty < parseInt(itm.orderedQty, 10) ? true : false;
											}
										}}
										);
										const relationShipTypes =  self.props.state.user.relationShipPartyList && self.props.state.user.relationShipPartyList.responseObject && self.props.state.user.relationShipPartyList.responseObject.filter(party => party.RELATIONSHIP_STATUS === 'A').map(item => item.RELATIONSHIP_TYPE);
										const invoice = relationShipTypes && self.props.state.user.allTcaList && self.props.state.user.allTcaList.responseObject && self.props.state.user.allTcaList.responseObject.filter(item => relationShipTypes.includes(item.tcaRelationshipName));
										const defaultInvoice =  self.props.state.user.allTcaList && self.props.state.user.allTcaList.responseObject && self.props.state.user.allTcaList.responseObject.filter(item => item.tcaRelationshipName === 'Default');
										const invoiceAge = invoice && invoice.length > 0 ? invoice[0].invoiceAge : defaultInvoice[0].invoiceAge;
										let invoiceDateFinal=this.props.pickTheDateFromString(this.state.filterListOfOrders.param.filterBy == 'serialNumber'?invoice_DATE:invoiceDate);
										isOlderThanTwoYear = moment(invoiceDateFinal).isBefore(moment().subtract(2, 'years'));
										isOlderThanYear = moment(invoiceDateFinal).isBefore(moment().subtract(1, 'years'));
										if(invoiceDateFinal && moment(invoiceDateFinal).isBefore(moment().subtract(invoiceAge, 'days'), 'day')  && self.props.state.user.userDetails.typeOfUser == "customer" && ['Scrap', 'Damage Allowances', "Push/Pull Credit"].includes(creditType)) {
											showOlderThanInvoiceMessage= true;
										}
										if(invoiceDateFinal && moment(invoiceDateFinal).isBefore(moment().subtract(invoiceAge, 'days'), 'day')  && self.props.state.user.userDetails.typeOfUser == "employee" && ['Scrap', 'Damage Allowances', "Push/Pull Credit"].includes(creditType)) {
											showOlderThanInvoiceMessageForEmployee= true;
										}
										if(this.state.filterListOfOrders.param.filterBy === 'serialNumber' && (isReturnedSerialNumberInCurrentOrder || isCreditedSerialNumberInCurrentOrder)) {
											serialNumberHyperLink= true;
										}
										return <tr key={index}>
											{(showOlderThanInvoiceMessage || serialNumberHyperLink || isOlderThanTwoYear || (isOlderThanYear && CUSTOMERCLASSCODE === "AS-IS")) ?<td className="orderNumber">{orderHeader.orderNumber}</td>:<td className="orderNumber"><a className="bold" href="" onClick={this.handleFetchOrderDetails.bind(this, orderHeader, 'requestcreditstep1')}>{orderHeader.orderNumber}</a></td>}
											<td className="orderDate">{this.props.formatDate(orderHeader.orderDate, 'MM/DD/YY')}</td>
											<td className="invoiceNumber">{this.state.filterListOfOrders.param.filterBy == 'serialNumber'?invoice_NUMBER:invoiceNumber}</td>
											<td className="invoiceDate">{invoiceDateFinal}</td>
											<td className="poNumber">{orderHeader.ponumber}</td>
											<td className="product">{this.state.filterListOfOrders.param.filterBy == 'serialNumber'?attribute1:""}</td>
											{(!isAlreadyRetrnQtyLessThenOrdered || showOlderThanInvoiceMessage || serialNumberHyperLink || hyperlinkSerial || creditType == "Delivery/Services/Fees" || isOlderThanTwoYear || (isOlderThanYear && CUSTOMERCLASSCODE === "AS-IS")) ?<td className="serial">{this.state.filterListOfOrders.param.filterBy == 'serialNumber'?fm_SERIAL_NUMBER:""}</td>
											:<td className="serial"><a className="bold" href="" onClick={this.handleContinue.bind(this, orderHeader, attribute1, fm_SERIAL_NUMBER, resultLineNumber)}>{this.state.filterListOfOrders.param.filterBy == 'serialNumber'?fm_SERIAL_NUMBER:""}</a></td>}
											<td>{this.state.filterListOfOrders.param.filterBy === 'serialNumber' && returnLines && returnLines.length > 0 && <a href="" onClick={this.handleReturnLinesDetails.bind(this, returnLines, orderHeader)}>Click here</a>}</td>
										</tr>
									})}
								</tbody>
							</table>
							{isOlderThanYear && CUSTOMERCLASSCODE === "AS-IS" ? <p className="bold red">{this.state.olderThanYearMessage}</p> 
							:(showOlderThanInvoiceMessage || showOlderThanInvoiceMessageForEmployee) && <p className="bold red">{this.state.olderThanInvoiceAgeMessage}</p>}
							{isOlderThanTwoYear && <p className="bold red">{this.state.olderThanTwoYearMessage}</p> }
							{this.state.filterListOfOrders.param.filterBy === 'serialNumber' && (isReturnedSerialNumberInAnyOrder || isCreditedSerialNumberInAnyOrder) ? <p className="bold red">{`This serial number has already been ${isReturnedSerialNumberInAnyOrder && isCreditedSerialNumberInAnyOrder ? 'credited/returned' : isCreditedSerialNumberInAnyOrder ? 'credited' : 'returned'}:`}</p>:''}
							{this.state.filterListOfOrders.param.filterBy === 'serialNumber' && (isReturnedSerialNumberInAnyOrder || isCreditedSerialNumberInAnyOrder) ? <table className="dataTable returnProductsOrderListTable withAlternatingTbodyElements">
								<thead>
									<tr>
										<th className="orderNumber">CSO (Order number)</th>
										<th className="invoiceNumber">Invoice #</th>
										<th className="invoiceDate">Invoice Date</th>
										<th className="product">Product</th>
										{isCreditedSerialNumberInAnyOrder && <th>Reason</th>}
										<th className="serial">Serial#</th>
									</tr>
								</thead>
								<tbody>
									{this.state.filterListOfOrders.param.filterBy === 'serialNumber' && self.props.state.order.serialCreditData && self.props.state.order.serialCreditData.length > 0 && self.props.state.order.serialCreditData.filter(item => item.line_TYPE === "Return Line" || item.line_TYPE === "Other Credit").map((itm, index)=>{
											return <tr key={index}>
											<td className="orderNumber">{itm.order_NUMBER}</td>
											<td className="invoiceNumber">{itm.invoice_NUMBER}</td>
											<td className="invoiceDate">{itm.invoice_DATE && moment(itm.invoice_DATE).format('MM/DD/YYYY')}</td>
											<td className="product">{itm.attribute1}</td>
											{isCreditedSerialNumberInAnyOrder && <td>{itm.returnReason}</td>}
											<td className="serial">{itm.fm_SERIAL_NUMBER}</td>
										</tr>
										})
									}
								</tbody>
							</table>:""}
						</div>
					}
					{
						self.state.showSerialErrorMessage && self.state.showRequestReturnFileWarningDialog && 
						<RequestReturnFileWarningDialog content ={`Serial number should have 2 letters and 6 numbers.`} handleDialog={this.handleDialog.bind(this)} showDialog={true}/>
					}
					{this.state.showSelectProductsToReturnOverlayDialog?<SelectProductsToReturnOverlayDialog handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
				</div>

				{/*mobile view*/}

				<div className="d-block d-sm-none container"> 
					<div className="d-block d-sm-none container">
						<h1 className="pageTitle">Request Credit</h1>
						<p>To request a credit, select the credit type first, and then find the order containing the product(s) for which you are requesting credit.</p>
						<div className="mb-3">
							<select onChange={this.updateParams.bind(this, 'filterListOfOrders')} value={creditType} className={"form-select " + this.state.filterListOfOrders.error.creditTypeError} name="creditType">
									<option value="">Choose the type of credit you are requesting</option>
									{allowedCreditTypesList.map((item, index) => {
										return <option value={item} key={index}>{item}</option>
									})}
								</select>
						</div>
						
							<form name="row returnProductsFilterForm" id="returnProductsFilterForm" onSubmit={this.handleFilterListOfOrders.bind(this)}>
									<div className='requestCreditBlueBox p-2'>
										<h3 style={{marginBottom: 14, marginTop: 14}}>Filter the list of orders by using the search criteria below.</h3>
										<p>Filter by P.O. #, CSO (order number), Serial #, Invoice # or Order Reference #</p>
										<div className='p-1'>
										<p>
												<select ref={(select) => this.filterBy = select} defaultValue={this.state.filterListOfOrders.param.filterBy} name="filterBy" onChange={this.updateParams.bind(this, 'filterListOfOrders')} className={"form-select " + this.state.filterListOfOrders.error.filterByError}>
													<option value="">Select one...</option>
													<option value="poNumber">P.O. #</option>
													<option value="orderNumber">CSO (Order number)</option>
													<option value="serialNumber">Serial #</option>
													<option value="invoiceNumber">Invoice #</option>
													<option value="referenceNumber">Order Reference # (CTN #)</option>
												</select>
										</p>
										{this.state.filterListOfOrders.param.filterBy !== 'serialNumber' &&
												<p>
													<input ref={(input) => this.filterString = input} onChange={this.updateParams.bind(this, 'filterListOfOrders')} className={"fullWidth form-control inputHeight " + this.state.filterListOfOrders.error.filterStringError + (filterBy === 'poNumber' || filterBy === 'referenceNumber' ? ' text-transform-uppercase' : '')} type="text" name="filterString" disabled={this.state.filterListOfOrders.param.filterBy === ''} value={this.state.filterListOfOrders.param.filterString} />
												</p>}


												{this.state.filterListOfOrders.param.filterBy === 'serialNumber' &&
												<div className={this.state.filterListOfOrders.error.modelNumberError + ' auto-width-input'}>
													<AccountNumberAutoSuggests onChangeProductNumberTextBox={this.handleChangeProductNumberTextBox.bind(this)} updateQuickOrderState={this.handleProductNumberChange.bind(this)} size={8} placeHolder="Model #" />
													{inValid
														?<span className="red">Invalid product Number.</span>
														:null
													}
												</div>
											}
											{this.state.filterListOfOrders.param.filterBy === 'serialNumber' &&
												<p>
													<input placeholder="Serial # e.g., AB123456" 
													ref={(input) => this.serialNumber = input} 
													onChange={this.updateParams.bind(this, 'filterListOfOrders')} 
													className={"fullWidth form-control inputHeight" + this.state.filterListOfOrders.error.serialNumberError} 
													type="text" 
													name="serialNumber"
													
													maxLength={8} 
													disabled={this.state.filterListOfOrders.param.filterBy !== 'serialNumber'} 
													value={this.state.filterListOfOrders.param.serialNumber} />
												</p>}

												<p className='d-flex'>
												<input type="submit" value="Search" className='btn btnSize' />
												&nbsp; &nbsp;
												<input type="reset" className="blue looksLikeALink" onClick={this.handleResetForm.bind(this, 'other')} value="Clear Search" />
											</p>
										</div>
										
										<div className="clear" />
									</div>
							</form>

							<p className="red bold">{this.state.errorMessage}</p>
							<p className="bold"><b>{this.state.filterConfirmationMessage}</b></p>
							{this.state.showClickHereLink && <p>Can’t find your order please click <a href="" onClick={this.showForm.bind(this, true)}>here</a></p>}
							{!this.state.showClickHereLink && requestCreditList && requestCreditList.status && !this.state.filterConfirmationMessage &&
								<div>
									<div className="bold big orderDetails headerColor">{requestCreditList.responseObject.length} Orders</div>

									
										{requestCreditList.responseObject.length > 0 && requestCreditList.responseObject.map((item, index) => {
											let { orderHeader, orderDetail } = item,
												{ attribute } = orderHeader.attributes;
											attribute = attribute?_.find(attribute, ['name', 'Attribute2']):null;
											let isReturnedSerialNumberInCurrentOrder = false, isCreditedSerialNumberInCurrentOrder = false;
											const {
												invoiceNumber,
												invoiceDate,
											} = self.processInvoiceNumberDate(orderHeader);
											let invoice_NUMBER , invoice_DATE, attribute1, fm_SERIAL_NUMBER, line_NUMBER ='';
											self.props.state.order.serialCreditData && self.props.state.order.serialCreditData.length > 0 && self.props.state.order.serialCreditData.filter((itm)=>{
												if(itm.order_NUMBER == orderHeader.orderNumber){
													invoice_NUMBER =itm.invoice_NUMBER;
													invoice_DATE =  itm.invoice_DATE; 
													attribute1 = itm.attribute1;
													fm_SERIAL_NUMBER = itm.fm_SERIAL_NUMBER;
													line_NUMBER = itm.line_NUMBER;
												}
												if (itm.originalOrderNumber === orderHeader.orderNumber) {
													if (itm.line_TYPE === 'Return Line') {
														isReturnedSerialNumberInCurrentOrder = true;
														isReturnedSerialNumberInAnyOrder = true;
													} else if (itm.line_TYPE === 'Other Credit') {
														isCreditedSerialNumberInCurrentOrder = true;
														isCreditedSerialNumberInAnyOrder = true;
													}
												}
											});
											let returnLines ='';
											let serialNumberHyperLink = false;
											let hyperlinkSerial = false;
											let resultLineNumber = line_NUMBER.split('.');
											orderDetail && orderDetail.orderLine && orderDetail.orderLine.map(itm => {
												if(itm.item === attribute1  && itm.lineNum == resultLineNumber[0] && itm.shipmentNum == resultLineNumber[1] && itm.returnDetails && itm.returnDetails.returnLine && itm.returnDetails.returnLine.length >0){
													returnLines = itm.returnDetails.returnLine.filter(returnItems =>{
														let orderedQuantity =parseInt(itm.orderedQty, 10);
														let calculatedReturnQuantity =orderedQuantity - returnItems.authorizedQty;
														if(calculatedReturnQuantity == 0){
															hyperlinkSerial = true;
														}
														if(calculatedReturnQuantity > 0){
															hyperlinkSerial = false;
														}
														return returnItems.lineType.toLowerCase() !== 'bill only line'
											});
											let totalAlreadyRetrnedQty = 0 
											if(returnLines) {
												totalAlreadyRetrnedQty = _.sumBy(returnLines,'authorizedQty');
												isAlreadyRetrnQtyLessThenOrdered = totalAlreadyRetrnedQty < parseInt(itm.orderedQty, 10) ? true : false;
											}  
											}}
											);
											const relationShipTypes =  self.props.state.user.relationShipPartyList && self.props.state.user.relationShipPartyList.responseObject && self.props.state.user.relationShipPartyList.responseObject.filter(party => party.RELATIONSHIP_STATUS === 'A').map(item => item.RELATIONSHIP_TYPE);
											const invoice = relationShipTypes && self.props.state.user.allTcaList && self.props.state.user.allTcaList.responseObject && self.props.state.user.allTcaList.responseObject.filter(item => relationShipTypes.includes(item.tcaRelationshipName));
											const defaultInvoice =  self.props.state.user.allTcaList && self.props.state.user.allTcaList.responseObject && self.props.state.user.allTcaList.responseObject.filter(item => item.tcaRelationshipName === 'Default');
											const invoiceAge = invoice && invoice.length > 0 ? invoice[0].invoiceAge : defaultInvoice[0].invoiceAge;
											let invoiceDateFinal=this.props.pickTheDateFromString(this.state.filterListOfOrders.param.filterBy == 'serialNumber'?invoice_DATE:invoiceDate)
											if(invoiceDateFinal && moment(invoiceDateFinal).isBefore(moment().subtract(invoiceAge, 'days'), 'day')  && self.props.state.user.userDetails.typeOfUser == "customer" && ['Scrap', 'Damage Allowances', "Push/Pull Credit"].includes(creditType)) {
												showOlderThanInvoiceMessage= true;
											}
											if(invoiceDateFinal && moment(invoiceDateFinal).isBefore(moment().subtract(invoiceAge, 'days'), 'day')  && self.props.state.user.userDetails.typeOfUser == "employee" && ['Scrap', 'Damage Allowances', "Push/Pull Credit"].includes(creditType) ) {
												showOlderThanInvoiceMessageForEmployee= true;
											}									
											if(this.state.filterListOfOrders.param.filterBy === 'serialNumber' && (isReturnedSerialNumberInCurrentOrder || isCreditedSerialNumberInCurrentOrder)) {
												serialNumberHyperLink= true;
											}
											return <div className="accordion removeAccBorder accordion-borderless" id={`accordionRequestCredit1${index}`}  key={index}>
														<div className="accordion-item">
															<h2 className="accordion-header" id={`heading${index}`}>
																<button className="accBtn accordion-button font-size-14 collapsed " type="button" data-bs-toggle="collapse" data-bs-target={`#collapse${index}`} aria-expanded="true" aria-controls={`collapse${index}`}>
																{`ORDER `} {(showOlderThanInvoiceMessage || serialNumberHyperLink) ?<span className="orderNumberSpan">{orderHeader.orderNumber}</span>:<span className="orderNumberSpan"><a className="bold" href="" onClick={this.handleFetchOrderDetails.bind(this, orderHeader, 'requestcreditstep1')}>{orderHeader.orderNumber}</a></span>}
																</button>
															</h2>

															<div id={`collapse${index}`}
																className={`accordion-collapse collapse accBody accHeight350 ${index == 0 ? 'show' : ''}`} 
																aria-labelledby={`heading${index}`}>
																
																<div className=" accBodyContainer">
																<div className="row ">
																	<div className="col-8 fw-bold">ORDER DATE</div>
																	<div className="col-4 text-end">{this.props.formatDate(orderHeader.orderDate, 'MM/DD/YY')}</div>
																	<hr className="hr hrSpec" />
																</div>
																<div className="row ">
																	<div className="col-8 fw-bold">INVOICE #</div>
																	<div className="col-4 text-end">{this.state.filterListOfOrders.param.filterBy === 'serialNumber' ? invoice_NUMBER : invoiceNumber}</div>
																	<hr className="hr hrSpec" />
																</div>
																<div className="row ">
																	<div className="col-8 fw-bold">INVOICE DATE</div>
																	<div className="col-4 text-end">{invoiceDateFinal}</div>
																	<hr className="hr hrSpec" />
																</div>
																<div className="row ">
																	<div className="col-8 fw-bold">PO #</div>
																	<div className="col-4 text-end">{orderHeader.ponumber}</div>
																	<hr className="hr hrSpec" />
																</div>
																<div className="row ">
																	<div className="col-6 fw-bold">PRODUCT</div>
																	<div className="col-6 text-end">{this.state.filterListOfOrders.param.filterBy === 'serialNumber' ? attribute1 : ""}</div>
																	<hr className="hr hrSpec" />
																</div>
																<div className="row ">
																	<div className="col-8 fw-bold">SERIAL #</div>
																	<div className="col-4 text-end">
																{(!isAlreadyRetrnQtyLessThenOrdered || showOlderThanInvoiceMessage || serialNumberHyperLink || hyperlinkSerial || creditType === "Delivery/Services/Fees") ? 
																		<span>{this.state.filterListOfOrders.param.filterBy === 'serialNumber' ? fm_SERIAL_NUMBER : ""}</span>
																		: 
																		<a className="bold" href="" onClick={this.handleContinue.bind(this, orderHeader, attribute1, fm_SERIAL_NUMBER, resultLineNumber)}>
																				{this.state.filterListOfOrders.param.filterBy == 'serialNumber'?fm_SERIAL_NUMBER:""}
																		</a>																 
																	}
																	</div>
																	<hr className="hr hrSpec" />
																</div>
																
																	<div className="row ">
																		<div className="col-3"></div>
																		<div className="col-9 text-end">
																		{this.state.filterListOfOrders.param.filterBy === 'serialNumber' && returnLines && returnLines.length > 0 && (<a href="#" onClick={(e) => { e.preventDefault(); this.handleReturnLinesDetails(returnLines, orderHeader); }}>
																		Previous Returns/Credits
																			</a>)}
																		</div>
																	
																	</div>
		
															</div>
																
															</div>
														</div>
												</div>
										})}

										{(showOlderThanInvoiceMessage || showOlderThanInvoiceMessageForEmployee) && <p className="bold red requestCreditMessageFont">{this.state.olderThanInvoiceAgeMessage}</p>}	
										
											{this.state.filterListOfOrders.param.filterBy === 'serialNumber' && self.props.state.order.serialCreditData && self.props.state.order.serialCreditData.length > 0 && self.props.state.order.serialCreditData.filter(item => item.line_TYPE === "Return Line" || item.line_TYPE === "Other Credit").map((itm, index)=>{
											return <div className="accordion removeAccBorder accordion-borderless" id={`accordionRequestReturnCredit1${index}`}  key={index}>
												<div className="accordion-item">
													<h2 className="accordion-header" id={`headingReturn${index}`}>
														<button className="accBtn accordion-button font-size-14 collapsed " type="button" data-bs-toggle="collapse" data-bs-target={`#collapseReturn${index}`} aria-expanded="true" aria-controls={`collapseReturn${index}`}>
															{`RETURN ORDER    ${itm.order_NUMBER}`} 
														</button>
													</h2>	

													<div id={`collapseReturn${index}`}
																className={`accordion-collapse collapse accBody accHeight275 show`} 
																aria-labelledby={`headingReturn${index}`}
																show>

																<div className="container accBodyContainer">
																	<div className="row ">
																	<p className="bold red requestCreditMessageFont">{`This serial number has already been ${itm.line_TYPE === 'Other Credit' ? 'credited' : 'returned'}`}</p>
																		<hr className="hr hrSpec" />
																	</div>

																	<div className="row ">
																		<div className="col-8 fw-bold">Invoice #</div>
																		<div className="col-4 text-end">{itm.invoice_NUMBER}</div>
																		<hr className="hr hrSpec" />
																	</div>

																	<div className="row ">
																		<div className="col-8 fw-bold">Invoice Date</div>
																		<div className="col-4 text-end">{itm.invoice_DATE && moment(itm.invoice_DATE).format('MM/DD/YYYY')}</div>
																		<hr className="hr hrSpec" />
																	</div>

																	<div className="row ">
																		<div className="col-6 fw-bold">Product</div>
																		<div className="col-6 text-end">{itm.attribute1}</div>
																		<hr className="hr hrSpec" />
																	</div>

																	{itm.line_TYPE === 'Other Credit' && <div className="row">
																		<div className="col-6 fw-bold">Reason</div>
																		<div className="col-6 text-end">{itm.returnReason}</div>
																		<hr className="hr hrSpec" />
																	</div>}

																	<div className="row ">
																		<div className="col-8 fw-bold">Serial#</div>
																		<div className="col-4 text-end">{itm.fm_SERIAL_NUMBER}</div>
																	</div>
																</div>

													</div>				
												</div>
											</div>
											})}
									
								</div>
								
								
							}

						{
							self.state.showSerialErrorMessage && self.state.showRequestReturnFileWarningDialog && 
							<RequestReturnFileWarningDialog content ={`Serial number should have 2 letters and 6 numbers.`} handleDialog={this.handleDialog.bind(this)} showDialog={true}/>
						}
							{this.state.showSelectProductsToReturnOverlayDialog?<SelectProductsToReturnOverlayDialog handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}

						<div style={{height:"200px"}}></div>
					</div>
				</div>

			</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getOrderList: (queryStringParams, callback) => dispatch(getOrderList(queryStringParams, callback)),
	saveRequestCreditList: (requestCreditList) => dispatch(saveRequestCreditList(requestCreditList)),
	saveRequestCreditPimData: (requestCreditPimdata) => dispatch(saveRequestCreditPimData(requestCreditPimdata)),
	saveSerialCreditData: (data) => dispatch(saveSerialCreditData(data)),
	setRequestCreditDetails: (data) => dispatch(setRequestCreditDetails(data)),
	updateRequestCreditParams: (data) => dispatch(updateRequestCreditParams(data)),
	ajaxRequestInitiated: (data) => dispatch(ajaxRequestInitiated(data)),
	ajaxRequestCompleted: (data) => dispatch(ajaxRequestCompleted(data)),
	getOrderDetails: (queryStringParams, callback) => dispatch(getOrderDetails(queryStringParams, callback)),
	dropProductSpecsEmail: (payload, hybridQueryParams, callback) => dispatch(dropProductSpecsEmail(payload, hybridQueryParams, callback)),
	savePreviousReturnAndCreditDetails: (data) => dispatch(savePreviousReturnAndCreditDetails(data)),
	sendEmailSuccessDialog: (emailSendSuccessDialog) => dispatch(sendEmailSuccessDialog(emailSendSuccessDialog)),
});

RequestCredit = connect(mapStateToProps, mapDispatchToProps)(RequestCredit);
export default RequestCredit;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/RequestCredit/requestCredit.js